import _ from 'lodash';

export const searchParamKey = 'dialogs';

export function getSearchParams() {
  const search = window.location.search;
  return new URLSearchParams(search);
}

export function setSearchParams(searchParams, navigate, options) {
  const to = {
    pathname: window.location.pathname,
    search: searchParams.toString()
  };

  navigate(to, options);
}

export function getSearchParam(key) {
  const searchParams = getSearchParams();
  return searchParams.get(key);
}

export function setSearchParam(key, value, navigate, options) {
  const searchParams = getSearchParams();
  if (value) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }
  setSearchParams(searchParams, navigate, options);
}

export function getDialogArray() {
  const searchParam = getSearchParam(searchParamKey);
  return JSON.parse(searchParam) || [];
}

export function setDialogArray(dialogArray, navigate, options) {
  if (dialogArray.length > 0) {
    setSearchParam(searchParamKey, JSON.stringify(dialogArray), navigate, options);
  } else {
    setSearchParam(searchParamKey, undefined, navigate, options);
  }
}

export function getRouteForDialog(dialogId) {
  const dialogArray = getDialogArray();
  const dialogConfig = _.find(dialogArray, dialogConfig => dialogConfig.id === dialogId);
  return dialogConfig?.route || '/';
}

export function setRouteForDialog(dialogId, route, navigate) {
  const dialogArray = getDialogArray();
  const dialogConfig = _.find(dialogArray, dialogConfig => dialogConfig.id === dialogId);
  dialogConfig.route = route;
  setDialogArray(dialogArray, navigate, { replace: true });
}

export default function launch(dialog, navigate, options) {
  const dialogArray = getDialogArray();
  dialogArray.push(dialog);
  setDialogArray(dialogArray, navigate, options);
};
